import React, { useEffect, useRef, useState, useCallback } from "react";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { NavLink, withRouter, useHistory } from "react-router-dom";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt, faKey } from "@fortawesome/free-solid-svg-icons";
import { getRoutes } from "../routes/index";
import cliente_logo from "../assets/img/logos/icone_logo.svg";
import cliente_foto from "../assets/img/logos/logo.svg";
import { API } from "../services/api";
import {  mostrarToastr, TOASTR_STRINGS } from '../helpers/utils';
import "./Sidebar.css";

import {
    Badge,
    Collapse,
    DropdownToggle,
    UncontrolledDropdown,
    DropdownMenu,
    DropdownItem,
    Col,
} from "reactstrap";
import { logoutDoSistema, sessionManager } from "../services/api";
import ModalAlterarSenha from "../pages/admin/ModalAlterarSenha";
import ModalConfirmacao from "../modals/ModalConfirmacao";

const initOpenRoutes = (location) => {
    /* Open collapsed element that matches current url */
    let openRoutes = sessionManager.openRoutes.get();

    if (openRoutes) return openRoutes;

    const routes = sessionManager.routes.get();

    if (!routes) return {}; // Return an empty object if routes are not available yet

    openRoutes = {};
    routes.forEach((route, index) => {
        const isActive = location.pathname.indexOf(route.path) === 0;
        openRoutes[index] = isActive;
    });

    return openRoutes;
};

const SidebarCategory = withRouter(({ name, badgeColor, badgeText, icon, isOpen, children, onClick, location, to }) => {
    const getSidebarItemClass = (path) => {
        return location.pathname.indexOf(path) !== -1 || (location.pathname === "/" && path === "/login") ? "active" : "";
    };
    return (
        <li className={"sidebar-item " + getSidebarItemClass(to)}>
            <span data-toggle="collapse" className={"sidebar-link " + (!isOpen ? "collapsed" : "")} onClick={onClick} aria-expanded={isOpen ? "true" : "false"}>
                <FontAwesomeIcon icon={icon} style={{ color: "#86174C" }}  fixedWidth className="align-middle mr-2" /> <span className="align-middle">{name}</span>
                {badgeColor && badgeText ? (
                    <Badge color={badgeColor} size={18} pill className="sidebar-badge">
                        {badgeText}
                    </Badge>
                ) : null}
            </span>
            <Collapse isOpen={isOpen}>
                <ul id="item" className={"sidebar-dropdown list-unstyled"}>
                    {children}
                </ul>
            </Collapse>
        </li>
    );
});

const SidebarItem = withRouter(({ id, name, badgeColor, badgeText, icon, location, to }) => {
    const getSidebarItemClass = (path) => {
        return location.pathname === path ? "active" : "";
    };

    return (
        <li className={"sidebar-item " + getSidebarItemClass(to)}>
            {to !== "/header" ? (
                <NavLink id={id} to={to} className="sidebar-link" activeClassName="active">
                    {icon ? (
                        <React.Fragment>
                            <FontAwesomeIcon icon={icon} style={{ color: "#86174C" }} fixedWidth className="align-middle mr-2" /> <span className="align-middle">{name}</span>
                        </React.Fragment>
                    ) : (
                        name
                    )}{" "}
                    {badgeColor && badgeText ? (
                        <Badge color={badgeColor} size={18} pill className="sidebar-badge">
                            {badgeText}
                        </Badge>
                    ) : null}
                </NavLink>
            ) : null}
        </li>
    );
});

const Sidebar = ({ location, sidebar }) => {
    const pathLocation = useLocation();
    const dadosUsuarioLogado = sessionManager.dadosUsuarioLogado.get();
    sessionManager.pathRoute.set(pathLocation.pathname);
    
    if (!dadosUsuarioLogado) window.location = "/login";

    const [routes, setRoutes] = useState([]);
    const [openRoutes, setOpenRoutes] = useState(() => initOpenRoutes(location));
    const [show, setShow] = useState(false);
    const [showSenha, setShowSenha] = useState(dadosUsuarioLogado?.alterar_senha == 1 ? true : false);

    const history = useHistory();


    useEffect(() => {
    if (routes.length > 0) {
        // Start with a copy of the current open routes to preserve manual toggles
        const newOpenState = { ...openRoutes };

        routes.forEach((route, index) => {
            // We only care about categories that have children
            if (route.children) {
                // Check if the current URL path starts with any of the child paths
                const isCategoryActive = route.children.some(child =>
                    location.pathname.startsWith(child.path.split("/:")[0])
                );

                // If the category is active, ensure it is marked as open
                if (isCategoryActive) {
                    newOpenState[index] = true;
                }
            }
        });

        // Update the state. React is smart enough to not re-render if the object is the same.
        setOpenRoutes(newOpenState);
    }
    // We only want this effect to run when the page location changes or routes are loaded.
}, [location, routes]);

    useEffect(() => {
        const loadRoutes = async () => {
            const storedRoutes = sessionManager.routes.get();
            if (storedRoutes) {
                setRoutes(storedRoutes);
            } else {
                const fetchedRoutes = await getRoutes();
                setRoutes(fetchedRoutes);
            }
        };

        loadRoutes();
    }, []);

    useEffect(() => {
        sessionManager.openRoutes.set(openRoutes);
    }, [openRoutes])

    const toggleSidebarCategory = useCallback((index) => {
        setOpenRoutes(prevOpenRoutes => ({
            ...prevOpenRoutes,
            [index]: !prevOpenRoutes[index]
        }));
    }, []);


    return (
        <React.Fragment>
            <nav className={classNames("sidebar", sidebar.isOpen || "toggled", !sidebar.isOnRight || "sidebar-right")}>
                <div className="sidebar-content">
                    <div className="sidebar-brand">
                        <Col className="d-flex justify-content-center align-items-center">
                            <div style={{ cursor: "pointer", width: "100%", height: 100 }} onClick={() => { history.push("/"); }}>
                                <img src={cliente_logo} alt="Logo" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                            </div>
                        </Col>
                    </div>

                    <ul
                        className="sidebar-nav">
                        {routes.map((route, index) => {
                            if (route.auth === 1) {
                                return (
                                    <React.Fragment key={index}>
                                        {route.header ? <li className="sidebar-header">{route.header}</li> : null}
                                        {route.children ? (
                                            <SidebarCategory
                                                name={route.name}
                                                badgeColor={route.badgeColor}
                                                badgeText={route.badgeText}
                                                icon={route.icon}
                                                to={route.path.split("/:")[0]}
                                                isOpen={openRoutes[index]}
                                                onClick={() => toggleSidebarCategory(index)}
                                            >
                                                {route.children.map((route, index) => {
                                                    if (route.auth === 1) {
                                                        return (
                                                            <SidebarItem
                                                                key={index}
                                                                id={route.id}
                                                                name={route.name}
                                                                to={route.path.split("/:")[0]}
                                                                badgeColor={route.badgeColor}
                                                                badgeText={route.badgeText}
                                                            />
                                                        );
                                                    }
                                                    return <></>;
                                                })}
                                            </SidebarCategory>
                                        ) : (
                                            <SidebarItem
                                                name={route.name}
                                                to={route.path.split("/:")[0]}
                                                icon={route.icon}
                                                badgeColor={route.badgeColor}
                                                badgeText={route.badgeText}
                                            />
                                        )}
                                    </React.Fragment>
                                );
                            }
                            return null;
                        })}
                    </ul>
                    <div className="footer">
                        <div className="sidebar-user">
                            <UncontrolledDropdown nav inNavbar className="ml-lg-1">
                                <DropdownToggle nav caret>
                                    <img
                                        src={dadosUsuarioLogado.url_foto ? dadosUsuarioLogado.url_foto : cliente_foto}
                                        alt="Foto"
                                        className="img-fluid rounded-circle mb-2"
                                        style={{ objectFit: "cover" }}
                                    />
                                </DropdownToggle>
                                <DropdownMenu right>

                                    <h6 className="card-subtitle text-muted"> Conta </h6>
                                    <DropdownItem onClick={() => setShowSenha(true)}>
                                        <div className="menu-user">
                                            <FontAwesomeIcon icon={faKey} /> Alterar Senha{" "}
                                        </div>
                                        <ModalAlterarSenha setShowSenha={setShowSenha} showSenha={showSenha} />
                                    </DropdownItem>

                                    <DropdownItem onClick={()=>{setShow(true)}}>
                                        <div className="menu-user">
                                            <FontAwesomeIcon icon={faSignOutAlt} /> Sair{" "}
                                        </div>
                                        <ModalConfirmacao
                                            mostrar={show}
                                            setMostrar={setShow}
                                            callbackSeSim={logoutDoSistema}
                                            mostrarBotaoNao
                                            textoTitulo={"Deseja realmente sair ?"}
                                        />
                                    </DropdownItem>

                                </DropdownMenu>
                            </UncontrolledDropdown>
                            <div className="font-weight-bold"> {dadosUsuarioLogado.nome} </div>
                            <small> E-mail: {dadosUsuarioLogado.email}</small>
                        </div>
                    </div>
                </div>
            </nav>
        </React.Fragment>
    );
};

export default withRouter(
    connect((store) => ({
        sidebar: store.sidebar,
    }))(Sidebar)
);
